import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SnagPortalService {
  constructor(private http: HttpClient) {}

  public getUrl(): Observable<any> {
    const path = 'api/inspections/login-as-inspector';
    return this.http.get(path);
  }
}
